import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    standalone: false
})
export class SkeletonComponent implements OnInit {
  @Input()
  style:
    | 'entity-h2-icon'
    | 'heading-h2-text'
    | 'heading-h3-text'
    | 'entity-h3-icon'
    | 'big-row-table'
    | 'big-toggle-buttons'
    | 'tab-filter-buttons'
    | 'ai-assist-prompt-tiles' = 'big-row-table';

  @Input()
  flex = false;

  @Input()
  grid = false;

  @Input()
  gridColumns: number | undefined;

  @Input()
  gap: number | undefined;

  @Input()
  containerPadding: number | undefined;

  // TODO: Add a count of how many parts/'bones'(?) to repeat
  @Input()
  count = 1;
  Array = Array;

  constructor() {}

  ngOnInit(): void {}
}
